import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { userType } from 'src/app/constants/global-constants';
import { IBlog, IBlogListResponse, IPostMonth, IPostMonthsResponse, IPostTag, IPostTagsResponse } from 'src/app/models/dashboard.models';
import { AuthService } from 'src/app/services/auth.service';
import { BlogService } from 'src/app/services/blog.service';
import { HomeService } from 'src/app/services/home.service';

@Component({
  selector: 'app-blog-listing',
  templateUrl: './blog-listing.component.html',
  styleUrls: ['./blog-listing.component.scss']
})
export class BlogListingComponent implements OnInit {

  tags: Array<IPostTag> = [];
  months: Array<IPostMonth> = [];
  recentBlogs: Array<IBlog> = [];
  blogs: Array<IBlog> = [];
  userType = userType;
  limit: number = 10;
  searchText: string = '';
  tempSearch: string = '';

  blogLoading: boolean;
  recentBlogLoading: boolean;
  tagLoading: boolean;
  monthLoading: boolean;
  showLoadMore: boolean = false;

  topicId: any;
  monthFilter: any;
  midwifeId: any;

  constructor(public authService: AuthService,
    public blogService: BlogService,
    public homeService: HomeService,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
        this.topicId = params.tagId
        this.monthFilter = params.month
        this.midwifeId = params.midwifeId
        this.blogs = [];
        if(this.topicId){
          this.getBlogsByTagId();
        }
        else if(this.monthFilter){
          this.getBlogsByMonth();
        }
        else if(this.midwifeId){
          this.getBlogsByMidwifeId();
        }
        else if(this.authService.user?.userType==this.userType.MIDWIFE){
          this.getMidwifeBlogs();
        }
      }
    );
    this.getRecentBlogs();
    this.getPostTags();
    this.getPostMonths();
  }

  getMidwifeBlogs(){
    let body = {
      offset: this.blogs.length,
      limit: this.limit
    };

    this.blogLoading = true;
    this.blogService.getMidwifeBlogs(body).subscribe((res: IBlogListResponse)=>{
      this.blogLoading = false;
      this.showLoadMore = res.payload.length < this.limit ? false : true;
      this.blogs = this.blogs.concat(res.payload);
      console.log("Midwife Blogs:", res.payload);
    },err=>{
      console.error("Midwife Blogs Error:", err);
      this.blogLoading = false;
    });
  }

  getRecentBlogs(){
    if(this.authService.user?.userType==this.userType.MUM && !this.midwifeId){
      this.blogLoading = true;
      this.homeService.getRecentBlogs(this.limit, this.blogs.length)
      .subscribe((res)=>{
        this.blogLoading = false;
        this.showLoadMore = res.payload.length < this.limit ? false : true;
        this.blogs = this.blogs.concat(res.payload);
        console.log("Blog Listing/Blogs: ", res.payload);
        this.blogLoading = false;
      },err=>{
        console.error("Blog Listing/Blogs Error: ", err);
      });
    }
    if(this.authService.user?.userType==this.userType.MIDWIFE || this.midwifeId){
      this.recentBlogLoading = true;
      this.homeService.getRecentBlogs(3, 0)
      .subscribe((res)=>{
        this.recentBlogs = res.payload;
        console.log("Blog Listing/Recent Blogs: ", this.recentBlogs);
        this.recentBlogLoading = false;
      },err=>{
        console.error("Blog Listing/Recent Blogs Error: ", err);
        this.recentBlogLoading = false;
      });
    }
  }

  getPostTags(){
    this.tagLoading = true;
    this.blogService.getBlogPostTags().subscribe((res: IPostTagsResponse)=>{
      this.tags = res.payload;
      console.log("Tags:", this.tags);
      this.tagLoading = false;
    },err=>{
      console.error("Tags Error:", err);
      this.tagLoading = false;
    });
  }

  getPostMonths(){
    this.monthLoading = true;
    this.blogService.getBlogPostMonths().subscribe((res: IPostMonthsResponse)=>{
      this.months = res.payload;
      console.log("Months:", this.tags);
      this.monthLoading = false;
    },err=>{
      console.error("Months Error:", err);
      this.monthLoading = false;
    });
  }

  searchBlog(){
    if(this.searchText.length){
      if(this.searchText != this.tempSearch){
        this.blogs = [];
        this.tempSearch = this.searchText;
      }
      let body = {
        searchPhrase: this.searchText,
        limit: this.limit,
        offset: this.blogs.length
      }
      this.blogLoading = true;
      this.blogService.searchBlog(body).subscribe((res: IBlogListResponse)=>{
        this.blogs = this.blogs.concat(res.payload);
        this.showLoadMore = res.payload.length < this.limit ? false : true;
        console.log("Search Blog List:", this.blogs);
        this.blogLoading = false;
      },err=>{
        console.error("Search Blog Error:", err);
        this.blogLoading = false;
        this.showLoadMore = false;
      });
    }
    else{
      this.blogs = [];
      this.tempSearch = '';
      if(this.authService.user?.userType==this.userType.MIDWIFE){
        this.getMidwifeBlogs();
      }else if(this.authService.user?.userType==this.userType.MUM){
        this.getRecentBlogs();
      }
    }
  }

  getBlogsByMidwifeId(){
    let body = {
      midwifeId: this.midwifeId,
      offset: this.blogs.length,
      limit: this.limit
    };

    this.searchText = '';
    this.tempSearch = '';
    this.blogLoading = true;
    this.blogService.getBlogsByMidwifeId(body)
    .subscribe((res)=>{
      this.showLoadMore = res.payload.length < this.limit ? false : true;
      this.blogs = this.blogs.concat(res.payload);
      console.log("Blog Listing/By Midwife Id: ", res.payload);
      this.blogLoading = false;
    },err=>{
      console.error("Blog Listing/By Tag Midwife Id Error: ", err);
      this.blogLoading = false;
    });
  }

  getBlogsByTagId(){
    let body = {
      topicId: this.topicId,
      offset: this.blogs.length,
      limit: this.limit
    };

    this.searchText = '';
    this.tempSearch = '';
    this.blogLoading = true;
    this.blogService.getBlogsByTagId(body)
    .subscribe((res)=>{
      this.showLoadMore = res.payload.length < this.limit ? false : true;
      this.blogs = this.blogs.concat(res.payload);
      console.log("Blog Listing/By Tag Id: ", res.payload);
      this.blogLoading = false;
    },err=>{
      console.error("Blog Listing/By Tag Id Error: ", err);
      this.blogLoading = false;
    });
  }

  getBlogsByMonth(){
    let body = {
      monthAndYear: this.monthFilter,
      offset: this.blogs.length,
      limit: this.limit
    };

    this.searchText = '';
    this.tempSearch = '';
    this.blogLoading = true;
    this.blogService.getBlogsByMonth(body)
    .subscribe((res)=>{
      this.showLoadMore = res.payload.length < this.limit ? false : true;
      this.blogs = this.blogs.concat(res.payload);
      console.log("Blog Listing/By Month: ", res.payload);
      this.blogLoading = false;
    },err=>{
      console.error("Blog Listing/By Month Error: ", err);
      this.blogLoading = false;
    });
  }

  loadMoreBlogs(){
    this.showLoadMore = false;
    if(this.searchText.length){
      this.searchBlog();
    }
    else if(this.topicId){
      this.getBlogsByTagId();
    }
    else if(this.midwifeId){
      this.getBlogsByMidwifeId();
    }
    else if(this.months){
      this.getBlogsByMonth();
    }
    else if(this.authService.user?.userType==this.userType.MIDWIFE){
      this.getMidwifeBlogs();
    }else if(this.authService.user?.userType==this.userType.MUM){
      this.getRecentBlogs();
    }
  }
}
